/**
 * Icon components for the Action Renderer Registry.
 *
 * Standard icons are imported from @untitledui/icons. Custom icons that have
 * no standard equivalent are kept as inline SVGs or re-exported from shared
 * modules.
 *
 * All exports use domain-specific names (e.g. EmailIcon, DeleteIcon) so the
 * registry reads naturally — `icon: EmailIcon` — while the underlying
 * components come from the icon library.
 */

// --- Standard icons (re-exported with domain-specific aliases) ---------------

export {
  Calendar as CalendarIcon,
  PlusCircle as CreateIcon,
  Trash03 as DeleteIcon,
  Mail01 as EmailIcon,
  LinkExternal01 as ExternalLinkIcon,
  Link01 as LinkIcon,
  Lock01 as LockIcon,
  GitMerge as MergeIcon,
  Users01 as TeamIcon,
  LinkBroken01 as UnlinkIcon,
} from '@untitledui/icons';

// --- Custom icons (no standard equivalent) -----------------------------------

/**
 * Pipeline/funnel icon — the canonical pipeline glyph now lives in the shared
 * CustomIcons module so non-proposals layers (settings nav, crm zero state,
 * entity-icon registry) can import it without crossing feature boundaries.
 * Re-exported here so existing registry imports keep working.
 */
export { PipelineIcon } from '@/lib/crm/utils/icons/CustomIcons';

/**
 * Ask User For Info icon — clipboard with form lines.
 * No standard equivalent in @untitledui/icons.
 */
interface IconProps {
  className?: string;
}

export function AskUserForInfoIcon({ className = 'w-5 h-5' }: IconProps) {
  return (
    <svg
      className={className}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      aria-hidden='true'
    >
      <path d='M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2' />
      <rect x='9' y='3' width='6' height='4' rx='1' />
      <line x1='9' y1='12' x2='15' y2='12' />
      <line x1='9' y1='16' x2='13' y2='16' />
    </svg>
  );
}
